<template>
  <article class="layout-section">
    <h2 class="layout-section__title">Main topics</h2>

    <section class="layout-grid">
      <div class="grid-pannel__box">
        <h3 class="grid-pannel__title">Technologie</h3>
      </div>

      <div class="grid-pannel__box">
        <h3 class="grid-pannel__title">Science</h3>
      </div>

      <div class="grid-pannel__box">
        <h3 class="grid-pannel__title">Energy</h3>
      </div>

      <div class="grid-pannel__box">
        <h3 class="grid-pannel__title">Economic Progress</h3>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'HomeTopics'
}
</script>
